<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">

          <div class="row btn-showcase">
            <div class="col-md-3 form-group">
              <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="create new account" (click)="onNew()">
                <i class="fa fa-plus" aria-hidden="true"></i>Add</button>
            </div>
          </div>

          <div class="custom-datatable">
          <ngx-datatable
          class='bootstrap'
          [columnMode]="ColumnMode.force"
          [rows]="publishersData"
          [externalPaging]="true"
          [count]="page.totalElements"
          [offset]="page.pageNumber"
          [limit]="page.size"
          (page)="setPage($event)"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [loadingIndicator]="true"
          
          >
          <ngx-datatable-column name="username">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">User name</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a href="/adm/publishers/{{ row.id }}">{{ row.username }}</a><small> ({{row.firstName}} {{row.lastName}})</small>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="email">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">E-mail</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.email }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="currentRevenue">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Current revenue</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.currentRevenue | currency}}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="paidOutInTotal">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Paid out in total</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.paidOutInTotal | currency }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Payterm" prop="payoutTerm.name">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Payout term</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.payoutTerm.name }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Rate">
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Rate</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
              {{ row.rate | percent }}
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="status" >
            <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
              <span class="myHeader txt-primary" (click)="sort()">Status</span>
            </ng-template>
            <ng-template let-row="row" headerClass="is-status" ngx-datatable-cell-template>
              <div *ngIf="row.status==1">
                Active
              </div>
              <div *ngIf="row.status==2">
                <span class="badge badge-danger">Locked</span>
              </div>
              <div *ngIf="row.status==3">
                <span class="badge badge-success">Registered</span>
              </div>
              <div *ngIf="row.status==4">
                <span class="badge badge-warning">Chgpass</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        </div>

      </div>
      </div>
    </div>
  </div>
</div>
<!-- Container-fluid Ends-->
